var React = require('react');

function WindowsPlatformIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 5.79v5.798h11.588V0H0v5.79zm12.412 0v5.798H24V0H12.412v5.79zM0 18.21V24h11.588V12.412H0v5.798zm12.412 0V24H24V12.412H12.412v5.798z","fill":"#fff"}));
}

WindowsPlatformIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = WindowsPlatformIcon;

WindowsPlatformIcon.default = WindowsPlatformIcon;
